import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { Box, useDisclosure } from '@chakra-ui/react';

import { useScheduleGenerateState } from 'View/schedule-generate/state';
import PopoverHandleHost from 'View/schedule-generate/component/popover-handle-host';

import styles from './styles.module.css';

const Dropzone = ({ children, location, isDisabled, schedules, rulesetDetail }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { updateState, popupLocation } = useScheduleGenerateState();
  const ref = useRef();

  useEffect(() => {
    const el = ref.current;

    return dropTargetForElements({
      element: el,
      getData: () => ({ location }),
      canDrop: ({ source }) => {
        const sourceLocation = source.data.host.location;
        return !isEqual(sourceLocation, location) && !isDisabled;
      },
    });
  }, [schedules, location, isDisabled]);

  const handleRightClick = (e) => {
    e.preventDefault();
    if (!isDisabled) {
      onToggle();
      const hasHost = schedules.some((schedule) => {
        return schedule.location[0] === location[0] && schedule.location[1] === location[1];
      });
      if (hasHost) {
        updateState({ popupLocation: location });
      } else {
        updateState({ popupLocation: location, handleHost: null });
      }
    }
  };

  const isPopoverOpen = isOpen && popupLocation[0] === location[0] && popupLocation[1] === location[1];

  return (
    <PopoverHandleHost isOpen={isPopoverOpen} onClose={onClose}>
      <Box ref={ref} className={styles['dropzone__container']} data-testid="dropzone" onContextMenu={handleRightClick}>
        {children}
      </Box>
    </PopoverHandleHost>
  );
};

export default Dropzone;
